import React from 'react';
import '../style.less';

interface CardHeader {
  logoPic: string,
  title: string,
  className?: string, 
}

const clsPrefix = "c-item-card";
const ItemCardHeader:React.FC<CardHeader> = ({
  logoPic,
  title,
  className
}) => {
  return (
    <div className={`${clsPrefix}__header ${className}`}>
      {
        logoPic ?
        <img src={logoPic} className={`${clsPrefix}__header--logo`} alt="" /> : 
        <div className={`${clsPrefix}__header--vicelogo`}>{title.slice(0,1)}</div>
      }
      <div className={`${clsPrefix}__header--title`}>{title}</div>
    </div>
  )
}

export default ItemCardHeader;